import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "welcome between" }
const _hoisted_3 = { class: "titleWelcome" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = {
  class: "link-list",
  "data-qa": "Liste-liens"
}
const _hoisted_6 = { class: "link-text" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "newEntry"
}
const _hoisted_11 = { for: "nameLink" }
const _hoisted_12 = { for: "link" }
const _hoisted_13 = { for: "file" }
const _hoisted_14 = { class: "footer" }
const _hoisted_15 = { for: "nameLink" }
const _hoisted_16 = { for: "link" }
const _hoisted_17 = { for: "file" }
const _hoisted_18 = { class: "footer" }
const _hoisted_19 = {
  key: 0,
  class: "content-body"
}
const _hoisted_20 = {
  key: 1,
  class: "content-body"
}

import { ref, computed, onMounted, nextTick, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { UseStoreUser } from '@/store/userStore';
import { UseStoreNews } from '@/store/newsStore';
import { UseStoreCategory } from '@/store/categoryStore';
import ProductCard from '@/components/ProductCard.vue';
import HeaderTop from '@/components/HeaderTop.vue';
import NewsWidget from '@/components/NewsWidget.vue';
import { UseClientStore } from '@/store/clientStore';
import habService from '@/services/habService';
import VideoWidget from '@/components/VideoWidget.vue';
import LiensUtilWidget from '@/components/LiensUtilWidget.vue';
import AstuceJourWidget from '@/components/AstuceJourWidget.vue';
import {
  handleMouseEnter,
  handleMouseLeave,
  showScroll,
} from '@/utils/ui-utils';
import { matomoTracker } from '@/utils/matomo';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  async setup(__props) {

let __temp: any, __restore: any

const { t, locale } = useI18n();
const searchKeyword = ref('');
const targetSection = ref<HTMLElement | null>(null);
const linkToDelete = ref<string | null>(null);
const newsStore = UseStoreNews();
const hasNews = computed(() => newsStore.news.length > 0);

const editableLink = ref<string | null>(null);
const isAddButtonDisabled = ref<boolean | null>(false);
const userStore = UseStoreUser();
const userLinks = computed(() =>
  userStore.userLinks.filter(link => !link.isAddedByAdmin)
);
const editableValue = ref<any>();
const uploadEdit = ref<boolean>(false);
const removeFile = () => {
  editableValue.value.file = null;
  editableValue.value.imageBase64 = '';
  editableValue.value.s3Key = '';
  uploadEdit.value = true;
};

watch(
  () => locale.value,
  newLang => {
    document.documentElement.setAttribute('lang', newLang);
  }
);

function confirmDelete(linkId: string): void {
  userStore.deleteUserLink(linkId);
}

function isValidUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return ['http:', 'https:'].includes(parsed.protocol);
  } catch {
    return false;
  }
}

function isValidEntry(
  entry: { name?: string; url?: string; file?: File },
  requireFile: boolean
): any {
  return (
    entry.name?.trim() &&
    entry.url?.trim() &&
    isValidUrl(entry.url) &&
    (!requireFile || (entry.file && entry.file.size > 0))
  );
}

function shouldDisable(isUpdate: boolean): boolean {
  return !isValidEntry(
    isUpdate ? editableValue.value : newEntry.value,
    !isUpdate
  );
}
const isEditDisabled = computed(() => {
  return !(
    editableValue.value.name?.trim() &&
    editableValue.value.url?.trim() &&
    isValidUrl(editableValue.value.url) &&
    editableValue.value.file &&
    editableValue.value.file.size > 0
  );
});
const isCreateDisabled = computed(() => shouldDisable(false));

function base64ToFile(base64: string, filename: string): File {
  // Fix wrong MIME type if needed
  if (base64.startsWith('data:application/octet-stream')) {
    if (base64.includes('svg')) {
      base64 = base64.replace('application/octet-stream', 'image/svg+xml');
    } else {
      base64 = base64.replace('application/octet-stream', 'image/png'); // fallback
    }
  }

  const arr = base64.split(',');
  const mimeMatch = arr[0].match(/:(.*?);/);

  if (!mimeMatch) {
    throw new Error('Invalid base64 format');
  }

  const mime = mimeMatch[1];
  const byteString = atob(arr[1]);
  const u8arr = new Uint8Array(byteString.length);

  for (let i = 0; i < byteString.length; i++) {
    u8arr[i] = byteString.charCodeAt(i);
  }

  return new File([u8arr], filename, { type: mime });
}

function editLink(link: any) {
  isAddButtonDisabled.value = true;
  isNew.value = false;
  editableLink.value = link.id;
  editableValue.value = { ...link };
  setTimeout(() => {
    changeFile(
      base64ToFile(editableValue.value.imageBase64, editableValue.value.s3Key),
      true
    );
  }, 1000);
}
const clientStore = UseClientStore();

const categoryStore = UseStoreCategory();

// await categoryStore.loadCategories();

;(
  ([__temp,__restore] = _withAsyncContext(() => newsStore.loadNews(1))),
  await __temp,
  __restore()
);

;(
  ([__temp,__restore] = _withAsyncContext(() => clientStore.getClientInfoFromRcu())),
  await __temp,
  __restore()
);

;(
  ([__temp,__restore] = _withAsyncContext(() => clientStore.getTeamsRhPortalLink())),
  await __temp,
  __restore()
);

habService.loadUserRolesFromToken();
const router = useRouter();
const hasRolesLoaded =
  Object.keys(userStore.userRoles).length > 0;
if (hasRolesLoaded && !userStore.hasAnyHubRole) {
  router.replace({ name: 'access-denied' });
}
if (userStore.hasAnyHubRole) {
  (
  ([__temp,__restore] = _withAsyncContext(() => userStore.getUserApps())),
  await __temp,
  __restore()
);
}

const acceptedTypes = ref('.jpeg, .png, .gif,.svg , .webp');

const isNew = ref(false);
const newEntry = ref<{
  name: string;
  url: string;
  file: File | null;
}>({
  name: '',
  url: '',
  file: null,
});

function changeFile(file: any, isupdate: boolean = false) {
  if (
    file &&
    (file.type.startsWith('image/') || file.type == 'application/octet-stream')
  ) {
    if (isupdate) editableValue.value.file = file;
    else newEntry.value.file = file;
  }
}
function createNewEntry() {
  isAddButtonDisabled.value = true;
  editableLink.value = null;
  isNew.value = true;
  nextTick(() => {
    targetSection.value?.scrollIntoView({ behavior: 'smooth' });
  });
}
const modalDisplayed = ref(false);
async function save() {
  isAddButtonDisabled.value = false;
  const userId = userStore.user.id;
  if (!userId) return;
  await userStore.createUserLink({
    name: newEntry.value.name,
    url: newEntry.value.url,
    userId,
    ...(newEntry.value.file ? { file: newEntry.value.file } : {}),
  });
  newEntry.value = {
    name: '',
    url: '',
    file: null,
  };

  isNew.value = false;
}
async function update() {
  isAddButtonDisabled.value = false;
  await userStore.updateUserLink({
    ...editableValue.value,
    userId: userStore.user.id,
  });
  editableLink.value = null;
  editableValue.value = null;
}
function createValue(event: string, field: string) {
  newEntry.value = {
    ...newEntry.value,
    [field]: event,
  };
}
function updateValue(event: string, field: string) {
  editableValue.value = {
    ...editableValue.value,
    [field]: event,
  };
}
function cancel(isUpdate: boolean = false) {
  isAddButtonDisabled.value = false;
  if (isUpdate) {
    editableLink.value = null;
    editableValue.value = null;
    uploadEdit.value = false;
  } else {
    newEntry.value = {
      name: '',
      url: '',
      file: null,
    };
    isNew.value = false;
  }
}
function showPersonnalisationModal() {
  modalDisplayed.value = true;
}
function closeModal() {
  isAddButtonDisabled.value = false;
  editableLink.value = null;
  editableValue.value = null;
  uploadEdit.value = false;
  modalDisplayed.value = false;
  isNew.value = false;
}
onMounted(async () => {
  const { locale } = useI18n();
  if (!userStore.userInDb || Object.keys(userStore.userInDb).length === 0) {
    try {
      await userStore.createUser({
        id: userStore.user.id!,
        username: userStore.user.username,
        favorite: [],
        preferences: { language: 'fr' },
      });
      console.log('User created successfully!');
    } catch (err) {
      console.log(t('errors.user'), err);
    }
  }
  const lang = userStore.userInDb?.preferences?.language || 'fr';
  locale.value = lang;
});

const refreshKey = ref(0);

function forceRefreshRecentlyOpened() {
  refreshKey.value++;
}

// Track ProductCard clicks
function handleProductCardClick(appId: string) {
  matomoTracker.trackEvent('ProductCard', 'click', appId);
}

return (_ctx: any,_cache: any) => {
  const _component_cs_button = _resolveComponent("cs-button")!
  const _component_cs_confirmation_popup = _resolveComponent("cs-confirmation-popup")!
  const _component_CsInputText = _resolveComponent("CsInputText")!
  const _component_cs_file_card = _resolveComponent("cs-file-card")!
  const _component_cs_upload = _resolveComponent("cs-upload")!
  const _component_cs_file_drop_zone = _resolveComponent("cs-file-drop-zone")!
  const _component_cs_modal = _resolveComponent("cs-modal")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_modelValue = _resolveDirective("modelValue")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderTop, {
      onUpdateSearch: _cache[0] || (_cache[0] = ($event: any) => (searchKeyword.value = $event))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)('dashboard.welcome')) + " " + _toDisplayString(_unref(userStore).user.firstName) + " ! ", 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_cs_modal, {
          "is-opened": modalDisplayed.value,
          title: _unref(t)('modal.subTitle'),
          description: `${userLinks.value.length} ${_unref(t)('dashboard.lienUtilTitle')}`,
          onClose: closeModal,
          class: "modalLink",
          "data-qa": "modal-personnaliser"
        }, {
          rightHeader: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_cs_button, {
                class: "btn-new-link",
                icon: "ajouter",
                type: "secondary",
                text: _unref(t)('modal.nouveauLien'),
                onClick: createNewEntry,
                "data-qa": "add-link",
                disabled: isAddButtonDisabled.value
              }, null, 8, ["text", "disabled"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLinks.value, (link) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: link.id,
                  class: _normalizeClass(['link-item', { 'edit-link': editableLink.value === link.id }])
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("strong", null, _toDisplayString(link.name), 1),
                    (editableLink.value !== link.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(link.url), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_cs_button, {
                      "aria-label": _unref(t)('links.editLink', { name: link.name }),
                      title: _unref(t)('links.editLink', { name: link.name }),
                      icon: "modifier",
                      type: "tertiary",
                      size: "tiny",
                      "data-cy-id": "button-success-7",
                      onClick: ($event: any) => (editLink(link))
                    }, null, 8, ["aria-label", "title", "onClick"]),
                    _createVNode(_component_cs_button, {
                      "aria-label": _unref(t)('links.deleteLink', { name: link.name }),
                      title: _unref(t)('links.deleteLink', { name: link.name }),
                      type: "secondary",
                      icon: "supprimer",
                      size: "small",
                      status: "destructive",
                      onClick: ($event: any) => (linkToDelete.value = link.id)
                    }, null, 8, ["aria-label", "title", "onClick"]),
                    (linkToDelete.value === link.id)
                      ? (_openBlock(), _createBlock(_component_cs_confirmation_popup, {
                          key: 0,
                          class: "confirmation-popup-delete",
                          "data-qa": "confirmation-popup-delete",
                          "is-opened": true,
                          onConfirmation: (result) => {
    if (result) confirmDelete(link.id)
    linkToDelete.value = null
  },
                          onCancel: _cache[1] || (_cache[1] = ($event: any) => (linkToDelete.value = null))
                        }, {
                          importantMessage: _withCtx(() => [
                            _createElementVNode("span", {
                              class: "Confirm-text",
                              innerHTML: _unref(t)('modal.confirmDeleteLien')
                            }, null, 8, _hoisted_9)
                          ]),
                          _: 1
                        }, 8, ["onConfirmation"]))
                      : _createCommentVNode("", true)
                  ]),
                  (editableLink.value == link.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(t)('modal.labelName')), 1),
                        _createVNode(_component_CsInputText, {
                          id: "nameLink",
                          category: "primary",
                          disabled: false,
                          minLength: "0",
                          maxLength: "50",
                          size: "regular",
                          placeholder: 'Exemple : Cegedim Business Services',
                          modelValue: editableValue.value.name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (updateValue($event, 'name')))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(t)('modal.labelLien')), 1),
                        _createVNode(_component_CsInputText, {
                          id: "link",
                          category: "primary",
                          disabled: false,
                          minLength: 0,
                          size: "regular",
                          placeholder: 'Exemple : https://www.cegedim-business-services.com/',
                          modelValue: editableValue.value.url,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (updateValue($event, 'url')))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(t)('modal.labelImage')), 1),
                        (!uploadEdit.value)
                          ? (_openBlock(), _createBlock(_component_cs_file_card, {
                              key: 0,
                              "file-name": editableValue.value.s3Key,
                              format: "line"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_cs_button, {
                                  icon: "effacer",
                                  type: "tertiary",
                                  status: "default",
                                  onClick: removeFile
                                })
                              ]),
                              _: 1
                            }, 8, ["file-name"]))
                          : _createCommentVNode("", true),
                        (uploadEdit.value)
                          ? (_openBlock(), _createBlock(_component_cs_upload, {
                              key: 1,
                              "show-file-name": "",
                              accept: acceptedTypes.value,
                              allowedTypes: acceptedTypes.value,
                              modelValue: editableValue.value.file,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editableValue.value.file) = $event)),
                              onChange: _cache[5] || (_cache[5] = ($event: any) => (changeFile($event, true)))
                            }, null, 8, ["accept", "allowedTypes", "modelValue"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_cs_button, {
                            type: "secondary",
                            text: _unref(t)('panel.Cancel'),
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (cancel(true))),
                            "data-qa": "cancel-button"
                          }, null, 8, ["text"]),
                          _createVNode(_component_cs_button, {
                            icon: "enregistrer",
                            type: "primary",
                            text: _unref(t)('modal.saveUpdate'),
                            onClick: update,
                            "data-qa": "save-button",
                            disabled: isEditDisabled.value
                          }, null, 8, ["text", "disabled"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ]),
            (isNew.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  ref_key: "targetSection",
                  ref: targetSection,
                  class: "newEntry"
                }, [
                  _createElementVNode("h3", null, _toDisplayString(_unref(t)('modal.nouveauLien')), 1),
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(t)('modal.labelName')), 1),
                  _withDirectives(_createVNode(_component_CsInputText, {
                    id: "nameLink",
                    category: "primary",
                    disabled: false,
                    minLength: "0",
                    maxLength: "50",
                    size: "regular",
                    placeholder: 'Exemple : Cegedim Business Services',
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (createValue($event, 'name')))
                  }, null, 512), [
                    [_directive_modelValue, newEntry.value.name]
                  ]),
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(t)('modal.labelLien')), 1),
                  _withDirectives(_createVNode(_component_CsInputText, {
                    id: "link",
                    category: "primary",
                    disabled: false,
                    minLength: 0,
                    size: "regular",
                    placeholder: 'Exemple : https://www.cegedim-business-services.com/',
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (createValue($event, 'url')))
                  }, null, 512), [
                    [_directive_modelValue, newEntry.value.url]
                  ]),
                  _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(t)('modal.labelImage')), 1),
                  _createVNode(_component_cs_file_drop_zone, {
                    id: "file",
                    acceptedTypes: acceptedTypes.value,
                    onChange: changeFile
                  }, null, 8, ["acceptedTypes"]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_cs_button, {
                      type: "secondary",
                      text: _unref(t)('panel.Cancel'),
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (cancel(false))),
                      "data-qa": "cancel-button"
                    }, null, 8, ["text"]),
                    _createVNode(_component_cs_button, {
                      icon: "enregistrer",
                      type: "primary",
                      text: _unref(t)('panel.Save'),
                      onClick: save,
                      "data-qa": "save-button",
                      disabled: isCreateDisabled.value
                    }, null, 8, ["text", "disabled"])
                  ])
                ], 512))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["is-opened", "title", "description"])
      ]),
      _createVNode(ProductCard, {
        apps: _unref(userStore).userApps,
        "search-keyword": searchKeyword.value,
        onOpened: forceRefreshRecentlyOpened,
        onClicked: handleProductCardClick,
        "data-qa": "my-apps-product-card",
        "favorite-list": _unref(userStore).userInDb.favorite || [],
        class: _normalizeClass(["ProductCard", { ProductCard: true, 'show-scroll': _unref(showScroll) }]),
        onMouseenter: _unref(handleMouseEnter),
        onMouseleave: _unref(handleMouseLeave)
      }, null, 8, ["apps", "search-keyword", "favorite-list", "onMouseenter", "onMouseleave", "class"]),
      (hasNews.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 16,
                  class: "liens-util"
                }, {
                  default: _withCtx(() => [
                    _createVNode(LiensUtilWidget, {
                      onOnClickPersonnalisation: showPersonnalisationModal,
                      onClose: _cache[10] || (_cache[10] = ($event: any) => (modalDisplayed.value = false))
                    }),
                    _createVNode(_component_el_row, {
                      gutter: 20,
                      class: "bottom-nav"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, {
                          span: 12,
                          class: "astuce-jour"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(AstuceJourWidget)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, {
                          span: 12,
                          class: "video-nav"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(VideoWidget)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 8,
                  class: "demo-radius2 news-widget"
                }, {
                  default: _withCtx(() => [
                    _createVNode(NewsWidget)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "content-without-news"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "liens-util1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(LiensUtilWidget, {
                      onOnClickPersonnalisation: showPersonnalisationModal,
                      onClose: _cache[11] || (_cache[11] = ($event: any) => (modalDisplayed.value = false))
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "demo-radius2 news-widget"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { class: "astuce-jour" }, {
                      default: _withCtx(() => [
                        _createVNode(AstuceJourWidget)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { class: "video-nav1" }, {
                      default: _withCtx(() => [
                        _createVNode(VideoWidget)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
    ])
  ], 64))
}
}

})